<script context="module">
    import Layout from '@/Layouts/Main.svelte';
    export const layout = Layout;
</script>

<script>
import { inertia } from '@inertiajs/inertia-svelte';
</script>

<svelte:head>
  <title>Legal terms</title>
</svelte:head>

<div class="py-4 pt-5 py-xl-5 position-relative">
  <div class="container">
    <div class="bg-white p-4 p-xl-5 mb-4 mb-xl-5">
      <div>
        <h1 class="m-0">Legal terms</h1>
      </div>
    </div>
    <div class="bg-white p-4 p-xl-5 mb-4 mb-xl-5">
      <div>

      </div>
    </div>
  </div>
</div>
